import FadeInSection from '../../../components/feature/FadeInSection';

const steps = [
  {
    number: '01',
    title: '無料相談',
    description:
      '和ははの活動内容やサービスについて、丁寧にご説明します。オンライン・対面どちらでも対応可能です。費用は一切かかりませんので、まずはお気軽にお申し込みください。',
    icon: 'ri-chat-smile-line',
  },
  {
    number: '02',
    title: '入会手続き',
    description:
      '説明会でご納得いただいた後、入会のお手続きを行います。書類のご記入や、魅力的なプロフィール写真の撮影サポートも行います。',
    icon: 'ri-file-text-line',
  },
  {
    number: '03',
    title: 'お相手探し・お見合い',
    description:
      'カウンセラーがあなたの希望条件を詳しくヒアリングし、最適なお相手をご提案します。ご希望の方にはお見合いのセッティングもお任せください。',
    icon: 'ri-search-eye-line',
  },
  {
    number: '04',
    title: '交際',
    description:
      'お相手と交際が始まったら、カウンセラーが引き続きサポートします。コミュニケーションのアドバイスや相談に丁寧に対応いたします。',
    icon: 'ri-heart-line',
  },
  {
    number: '05',
    title: '成婚',
    description:
      'お二人の関係が深まり、成婚へと進まれた際には、最後まで温かくサポートします。多くのカップルが和ははを通じて新しい人生のスタートを切られています。',
    icon: 'ri-star-line',
  },
];

export default function FlowSection() {
  return (
    <section className="section-padding" style={{ background: '#fff' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#fff8f2', color: '#8b4513', border: '1px solid #d4a574' }}
          >
            入会の流れ
          </p>
          <h2 style={{ color: '#4a3728' }}>ご入会から成婚までのステップ</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            あなたのペースに合わせて、丁寧にサポートいたします
          </p>
        </FadeInSection>

        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-[28px] md:left-1/2 top-0 bottom-0 w-[2px] hidden sm:block"
            style={{ background: 'linear-gradient(to bottom, #e8934e, #5a9e6f)', transform: 'translateX(-50%)' }}
          />

          <div className="space-y-8">
            {steps.map((step, index) => (
              <FadeInSection key={step.number} delay={index * 100}>
                <div className={`flex items-start gap-6 sm:gap-8 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  {/* Step Number Circle */}
                  <div className="relative shrink-0 flex flex-col items-center">
                    <div
                      className="flex items-center justify-center w-14 h-14 rounded-full font-bold text-white z-10 relative"
                      style={{ background: index % 2 === 0 ? '#e8934e' : '#5a9e6f', fontSize: '16px' }}
                    >
                      {step.number}
                    </div>
                  </div>

                  {/* Content Card */}
                  <div
                    className="flex-1 p-8 rounded-xl"
                    style={{
                      background: '#fff',
                      border: `2px solid ${index % 2 === 0 ? '#e8934e' : '#5a9e6f'}`,
                      borderRadius: '12px',
                    }}
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <span
                        className="flex items-center justify-center w-10 h-10 rounded-full"
                        style={{ background: index % 2 === 0 ? '#fff8f2' : '#f2f8f4' }}
                      >
                        <i
                          className={`${step.icon} text-xl`}
                          style={{ color: index % 2 === 0 ? '#e8934e' : '#5a9e6f' }}
                        ></i>
                      </span>
                      <h3 style={{ color: '#4a3728', fontSize: '20px', fontWeight: '700' }}>{step.title}</h3>
                    </div>
                    <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>
                      {step.description}
                    </p>
                  </div>
                </div>
              </FadeInSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
